import React, { ChangeEvent, FC } from 'react';
import {
  CardSelection,
  PaymentMethod,
  PaymentMethodSubscription,
  PaymentMethodTicket,
} from '../../../../../interfaces/merchants/resources/books';
import { UserMeReduxState } from '../../../../../interfaces/users';
import BooksPaymentMethods from '../BooksPaymentMethods';
import InputPaymentMyCreditCard from '../InputPaymentMyCreditCard';
import InputPaymentMySubscription from '../InputPaymentMySubscription';
import InputPaymentMyTicket from '../InputPaymentMyTicket';

type Props = {
  paymentMethods: PaymentMethod[];
  paymentMethod?: PaymentMethod;
  onChangePaymentMethod: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectCreditCard: (selection: string) => void;
  onSelectSubscription: (selection: string) => void;
  onSelectTicket: (selection: string) => void;
  isCreditCardShown: boolean;
  isSubscriptionShown: boolean;
  isTicketBookShown: boolean;
  loginUser: UserMeReduxState;
  cardSelection?: CardSelection;
  ticketSelection?: string;
  subscriptionSelection?: string;
};

const selectableProducts = (method: string, paymentMethods: PaymentMethod[]) =>
  paymentMethods.filter((element) => element.method === method)[0];

export const PaymentMethodSelect: FC<Props> = ({
  paymentMethods,
  paymentMethod,
  onChangePaymentMethod,
  onSelectCreditCard,
  isCreditCardShown,
  isSubscriptionShown,
  isTicketBookShown,
  loginUser,
  cardSelection,
  ticketSelection,
  subscriptionSelection,
  onSelectSubscription,
  onSelectTicket,
}) => {
  return (
    <BooksPaymentMethods
      payments={paymentMethods}
      selectedMethod={paymentMethod?.method}
      // @ts-expect-error strictFunctionTypes
      onChange={onChangePaymentMethod}
      subComponents={{
        credit_card: isCreditCardShown && (
          <InputPaymentMyCreditCard
            me={loginUser}
            onSelect={onSelectCreditCard}
            mySelection={cardSelection}
          />
        ),
        subscription: isSubscriptionShown && (
          <InputPaymentMySubscription
            paymentMethod={
              selectableProducts(
                'subscription',
                paymentMethods,
              ) as PaymentMethodSubscription
            }
            onSelect={onSelectSubscription}
            mySelection={subscriptionSelection}
          />
        ),
        ticket: isTicketBookShown && (
          <InputPaymentMyTicket
            paymentMethod={
              selectableProducts(
                'ticket',
                paymentMethods,
              ) as PaymentMethodTicket
            }
            onSelect={onSelectTicket}
            mySelection={ticketSelection}
          />
        ),
      }}
    />
  );
};
